import { LockOutlined, Visibility, VisibilityOff } from "@mui/icons-material";
import { Avatar, Box, Button, IconButton, InputAdornment, Paper, Snackbar, TextField, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import MuiAlert from '@mui/material/Alert';

const LogIn = () => {
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const toCanvas = () => {
        if (creds.password === "Biographix@123" && creds.email === "dev@gmail.com") {
            localStorage.setItem("userCreds", JSON.stringify(creds));
            navigate("/home");
        } else {
            setErrorMessage("Invalid Credentials");
            setOpenSnackbar(true);
        }
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    const [creds, setCreds] = useState({
        email: '',
        password: ''
    });

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            toCanvas();
        }
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #36454F 100%)',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: '-50%',
                right: '-50%',
                width: '100%',
                height: '100%',
                background: 'radial-gradient(circle, rgba(0,243,255,0.1) 0%, transparent 70%)',
                animation: 'pulse 4s ease-in-out infinite',
            },
            '@keyframes pulse': {
                '0%, 100%': { opacity: 0.6 },
                '50%': { opacity: 1 },
            },
        }}>
            <Box sx={{
                textAlign: 'center',
                pt: 6,
                pb: 2,
                position: 'relative',
                zIndex: 1
            }}>
                <Typography
                    variant="h2"
                    component="h1"
                    sx={{
                        color: 'white',
                        fontWeight: 700,
                        letterSpacing: 2,
                        textShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                        mb: 1
                    }}
                >
                    The BioGraphix
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: 'rgba(255, 255, 255, 0.9)',
                        fontSize: '1.1rem'
                    }}
                >
                    Professional Graphics Editor
                </Typography>
            </Box>

            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flex: 1,
                p: 2,
                position: 'relative',
                zIndex: 1
            }}>
                <Paper
                    elevation={12}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2.5,
                        maxWidth: 440,
                        width: '100%',
                        p: 4,
                        backgroundColor: 'white',
                        borderRadius: 3,
                        position: 'relative',
                        overflow: 'hidden',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: 4,
                            background: 'linear-gradient(90deg, #00F3FF 0%, #1e3c72 100%)',
                        },
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        mb: 1
                    }}>
                        <Avatar sx={{
                            bgcolor: 'primary.main',
                            width: 56,
                            height: 56,
                            mb: 2,
                            boxShadow: '0 4px 12px rgba(30, 60, 114, 0.3)'
                        }}>
                            <LockOutlined sx={{ fontSize: 32 }} />
                        </Avatar>
                        <Typography
                            align="center"
                            variant="h4"
                            sx={{
                                color: 'black',
                                fontWeight: 600,
                                mb: 0.5
                            }}
                        >
                            Welcome Back
                        </Typography>
                        <Typography
                            align="center"
                            variant="body2"
                            sx={{
                                color: 'text.secondary'
                            }}
                        >
                            Sign in to continue to your workspace
                        </Typography>
                    </Box>

                    <TextField
                        value={creds.email}
                        onChange={(e) => setCreds((prev) => ({
                            ...prev,
                            email: e.target.value
                        }))}
                        onKeyPress={handleKeyPress}
                        label="Email Address"
                        placeholder="dev@gmail.com"
                        aria-label="Enter your email address"
                        aria-required="true"
                        fullWidth
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.7)' }
                        }}
                        sx={{
                            input: { color: 'black' },
                            '& .MuiOutlinedInput-root': {
                                '&:hover fieldset': {
                                    borderColor: 'primary.main',
                                    borderWidth: 2
                                },
                            }
                        }}
                    />

                    <TextField
                        value={creds.password}
                        onChange={(e) => setCreds((prev) => ({
                            ...prev,
                            password: e.target.value
                        }))}
                        onKeyPress={handleKeyPress}
                        label="Password"
                        placeholder="Enter your password"
                        type={showPassword ? "text" : "password"}
                        aria-label="Enter your password"
                        aria-required="true"
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title={showPassword ? "Hide password" : "Show password"} arrow>
                                        <IconButton
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            aria-label={showPassword ? "Hide password" : "Show password"}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            )
                        }}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.7)' }
                        }}
                        sx={{
                            input: { color: 'black' },
                            '& .MuiOutlinedInput-root': {
                                '&:hover fieldset': {
                                    borderColor: 'primary.main',
                                    borderWidth: 2
                                },
                            }
                        }}
                    />

                    <Button
                        onClick={toCanvas}
                        variant="contained"
                        fullWidth
                        aria-label="Log in to your account"
                        sx={{
                            mt: 2,
                            py: 1.5,
                            fontSize: '1rem',
                            fontWeight: 600,
                            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                            boxShadow: '0 4px 12px rgba(30, 60, 114, 0.4)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #2a5298 0%, #00F3FF 100%)',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 6px 20px rgba(30, 60, 114, 0.5)',
                            }
                        }}
                    >
                        Sign In
                    </Button>

                    <Typography
                        align="center"
                        variant="caption"
                        sx={{
                            color: 'text.secondary',
                            mt: 1
                        }}
                    >
                        Demo credentials: dev@gmail.com / Biographix@123
                    </Typography>
                </Paper>
            </Box>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <MuiAlert
                    onClose={handleCloseSnackbar}
                    severity="error"
                    elevation={6}
                    sx={{ width: '100%' }}
                >
                    {errorMessage}
                </MuiAlert>
            </Snackbar>
        </Box>
    );
}

export default LogIn;
